import { useIsHelpVisible, useToggleHelpVisibility } from '@map/state/help';
import HelpProvider from '@shared/hooks/help/HelpProvider';
import useZendesk from '@shared/hooks/useZendesk';
import { ComponentProps } from 'react';

const ZendeskHelpProvider = (props: ComponentProps<typeof HelpProvider>) => {
  const isOpen = useIsHelpVisible();
  const toggleHelpVisibility = useToggleHelpVisibility();
  useZendesk(isOpen, toggleHelpVisibility);

  return <HelpProvider {...props} />;
};

export default ZendeskHelpProvider;
